import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketListComponent } from "./components/ticket-list/ticket-list.component";
import { TicketConversationComponent } from "./components/ticket-conversation/ticket-conversation.component";
import { TicketInterface } from "../../interfaces/ticket-interface";

@Component({
    selector     : 'app-ticket-conversation-detail',
    standalone   : true,
    imports      : [CommonModule, TicketListComponent, TicketConversationComponent],
    encapsulation: ViewEncapsulation.None,
    templateUrl  : './ticket-conversation-detail.component.html',
    styleUrl     : './ticket-conversation-detail.component.scss'
    
})
export class TicketConversationDetailComponent {
    activeTicket: TicketInterface | null = null;
    
    ngOnInit(): void {
        this.activeTicket = history.state.ticket;
    }
    
    onTicketSelected(ticket: TicketInterface): void {
        this.activeTicket = ticket;
    }
}
